import { createAction } from '../../../utils/redux/createAction';

const actionsScope = 'opentok-v2';

export const OPENTOK_TYPES = {
  TOGGLE_LOADING: `${actionsScope}/toggle-loading`,
  ADD_CONNECTION: `${actionsScope}/add-connection`,
  UPDATE_CONNECTION: `${actionsScope}/update-connection`,
  REMOVE_CONNECTION: `${actionsScope}/remove-connection`,
  UPDATE_INVITATIONS: `${actionsScope}/update-invitations`,
  SET_ACTIVE_ID: `${actionsScope}/set-active-id`,
  ADD_SPEAKER: `${actionsScope}/add-speaker`,
  REMOVE_SPEAKER: `${actionsScope}/remove-speaker`,
  SET_CONNECTED: `${actionsScope}/set-connected`,
  SET_START_CALL_TIME: `${actionsScope}/set-start-call-time`,
  SET_DURATION_DATA: `${actionsScope}/set-duration-data`,
  ADD_VIDEO_WARNING_ID: `${actionsScope}/add-video-warning`,
  REMOVE_VIDEO_WARNING_ID: `${actionsScope}/remove-video-warning`,
  FIND_SCREEN_SHARING: `${actionsScope}/find-screen-sharing`,
  SET_PIN: `${actionsScope}/set-pin`,
  RESET: `${actionsScope}/reset`,
};

export const opentokActions = {
  toggleLoading: createAction(OPENTOK_TYPES.TOGGLE_LOADING),
  addConnection: createAction(OPENTOK_TYPES.ADD_CONNECTION),
  updateConnection: createAction(OPENTOK_TYPES.UPDATE_CONNECTION),
  removeConnection: createAction(OPENTOK_TYPES.REMOVE_CONNECTION),
  updateInvitations: createAction(OPENTOK_TYPES.UPDATE_INVITATIONS),
  setActiveId: createAction(OPENTOK_TYPES.SET_ACTIVE_ID),
  addSpeaker: createAction(OPENTOK_TYPES.ADD_SPEAKER),
  removeSpeaker: createAction(OPENTOK_TYPES.REMOVE_SPEAKER),
  setConnected: createAction(OPENTOK_TYPES.SET_CONNECTED),
  setStartCallTime: createAction(OPENTOK_TYPES.SET_START_CALL_TIME),
  setDurationData: createAction(OPENTOK_TYPES.SET_DURATION_DATA),
  addVideoWarningId: createAction(OPENTOK_TYPES.ADD_VIDEO_WARNING_ID),
  removeVideoWarningId: createAction(OPENTOK_TYPES.REMOVE_VIDEO_WARNING_ID),
  findScreenSharing: createAction(OPENTOK_TYPES.FIND_SCREEN_SHARING),
  setPin: createAction(OPENTOK_TYPES.SET_PIN),
  reset: createAction(OPENTOK_TYPES.RESET),
};



// WEBPACK FOOTER //
// ./src/redux/opentok/reducer/actions.js